/* Explicit integration only. Host must pass its active offer API and selection hooks.
   Does not install listeners, intercept purchase events or change any theme automatically. */
(function(root){'use strict';
root.MMDCartBridge={install({product,offerApi,getSelection,setSelection,assetBase,config,afterClose}){
 if(!offerApi?.snapshot||!getSelection||!setSelection)throw Error('Explicit preview host hooks required');
 let syncing=true,cart;
 cart=root.MMDCart.mount({config,assetBase,nativeCart:root.MMD_NATIVE_PREVIEW?.[product],initial:{product,...getSelection()},onClose:afterClose,onChange(state){
  if(syncing)return;syncing=true;
  try{setSelection({pack:state.pack,sub:state.sub});const prior=offerApi.snapshot().selected;
   for(const k of prior)if(!state.selected.includes(k))offerApi.remove(k);
   for(const k of state.selected)if(!prior.includes(k))offerApi.select(k);
  }finally{syncing=false;}
 }});
 syncing=false;
 return {previewOnly:true,purchaseEnabled:false,open(trigger){syncing=true;try{const offers=offerApi.snapshot();cart.open({trigger,product,...getSelection(),selected:offers.selected,existing:offers.existing});}finally{syncing=false;}},snapshot:cart.snapshot,destroy:cart.destroy};
}};
})(window);
